import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";
import { useController, useForm } from "react-hook-form";
import { checkInvoiceAllow, createInvoiceCorrection, getCustomerInvoice, getInvoiceCorrection,getInvoiceCorrectionReasons, getInvoiceCorrectionReason, getTripByBookingNo, recalculateInvoiceCorrection, updateInvoiceCorrection } from "../../../Services/InvoiceCorrection.service";
import { showAlert } from "../../../Services/Shared.service";
import { Form } from "reactstrap";
import { fetchLocation, getCancelReasons } from "../../../Services/Booking.service";
import { useLocation, useNavigate, useNavigation } from "react-router";
import CancelInvoiceCorrection from "./CancelInvoiceCorrection";
import Select  from "react-select";
import { Controller } from "react-hook-form";
const InvoiceCorrection = () => {
    const {
        register,
        handleSubmit,
        control,
        reset,
        resetField,
        getValues,
        setValue,
        watch,
        formState: { errors,dirtyFields },
    } = useForm({
        defaultValues: {
            customerBalance: "",
            tollTax: "",
            totalDistance: "",
            tripStartTime: "",
            updatedTripStartTime: "",
            tripEndTime: "",
            updatedTripEndTime: "",
            pickupLocation: {},
            pickupAddress: "",
            destLocation: {},
            destAddress: "",
            customerName: "",
            customerNumber: "",
            updatedCustomerName: "",
            updatedCustomerNumber: "",
            invoiceCorrectionReason :""
        },
    });

    const [bookingNumber, setBookingNumber] = useState("")
    const [customerInvoice, setCustomerInvoice] = useState({})
    const [tripDetails, setTripDetails] = useState({})
    const [invoiceCorrectionDetails, setInvoiceCorrectionDetails] = useState({})
    const [invoiceCorrectionData, setInvoiceCorrectionData] = useState({})
    const [isUpdateInvoiceCorrection, setIsUpdateInvoiceCorrection] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isSave, setIsSave] = useState(false)
    const [reasonData, setReasonData] = useState([]);
    const [cancelBookingModal, setCancelBookingModal] = useState(false);
    const [invoiceCorrectionReasonData, setInvoiceCorrectionReasonData] = useState([])
    const [invoiceCorrectionReason, setInvoiceCorrectionReason] = useState("");
    const [isDropdownOpen,setIsDropdownOpen]=useState(false);
    const [error,setError]=useState("");
    const toggleCancelBookingModal = () =>
        setCancelBookingModal(!cancelBookingModal);
    const navigate = useNavigate();
    const location = useLocation();

    // Instead of dirty flag check actual field change which is reliable.
    const isDirty = Object.keys(dirtyFields).length > 0;
    useEffect(() => {
        if (isDirty) {
            setIsSave(false)
        }
    }, [isDirty])

    useEffect(() => {
        if (location?.state?.bookingNo) {
            setBookingNumber(location.state.bookingNo)
            searchBooking(location.state.bookingNo)
        }
    }, [location.state])

    const tripStartTimeField = useController({
        name: "tripStartTime",
        control,
    }).field;

    const tripEndTimeField = useController({
        name: "tripEndTime",
        control,
    }).field;

    const updatedTripStartTimeField = useController({
        name: "updatedTripStartTime",
        control,
    }).field;

    const updatedTripEndTimeField = useController({
        name: "updatedTripEndTime",
        control,
    }).field;

    const pickupLocationAddressField = useController({
        name: "pickupLocation",
        control,
    }).field;

    const customerBalanceField = useController({
        name: "customerBalance",
        control,
    }).field;

    const tollTaxField = useController({
        name: "tollTax",
        control,
    }).field;

    const totalDistanceField = useController({
        name: "totalDistance",
        control,
    }).field;

    const customerNameField = useController({
        name: "customerName",
        control
    }).field;

    const customerNumberField = useController({
        name: "customerNumber",
        control
    }).field;

     const updatedCustomerNameField = useController({
        name: "updatedCustomerName",
        control
    }).field;

    const updatedCustomerNumberField = useController({
        name: "updatedCustomerNumber",
        control
    }).field;
    
    const invoiceCorrectionReasonField = useController({
        name: "invoiceCorrectionReason",
        control,
        rules: {
        required: {
            value: true,
            message: "Please select a reason",
            },
        },
    }).field;

    const handlePickupLocationSelectChange = (data) => {
        pickupLocationAddressField.onChange(data.value);
    };

    const destLocationAddressField = useController({
        name: "destLocation",
        control,
    }).field;

    const handleDestLocationSelectChange = (data) => {
        destLocationAddressField.onChange(data.value);
    };

    useEffect(() => {
        getCancelReasons().then((result) => {
            if (result.status == 200 && result.data.length > 0) {
                const data = [];
                result.data.forEach((element) => {
                    if (element.isDeleted) return;
                    data.push({
                        value: element,
                        label: `${element.reason} - ${element.cancelType}`,
                    });
                });
                setReasonData(data);
            }
        });
    }, [])

    useEffect(() => {
        if (pickupLocationAddressField.value?.address) {
            setValue("pickupAddress", pickupLocationAddressField.value?.address);
        } else if (pickupLocationAddressField.value) {
            let obj = {
                key: null,
                isAgentApp: true,
                geoApi: true,
                address: pickupLocationAddressField.value||null,
                requestSource: "TMS"
            }
            fetchLocation(obj).then((result) => {
                if (result?.data?.length > 0) {
                    pickupLocationAddressField.onChange(result.data[0])
                }
            });
        } else {
            setValue("pickupAddress", "");
        }
    }, [pickupLocationAddressField.value]);

    useEffect(() => {
        if (destLocationAddressField.value?.address) {
            setValue("destAddress", destLocationAddressField.value?.address);
        } else if (destLocationAddressField.value) {
            let obj = {
                key: null,
                isAgentApp: true,
                geoApi: true,
                address: destLocationAddressField.value||null,
                requestSource: "TMS"
            }
            fetchLocation(obj).then((result) => {
                if (result?.data?.length > 0) {
                    destLocationAddressField.onChange(result.data[0])
                }
            });
        } else {
            setValue("destAddress", "");
        }
    }, [destLocationAddressField.value]);

    const getAddressData = async (inputValue) => {
        if (inputValue) {
            let obj = {
                key: inputValue,
                isAgentApp: true,
                geoApi: false,
                address: null,
                requestSource: "TMS"
            }
            return fetchLocation(obj).then((result) => {
                if (result?.data?.length > 0) {
                    let data = result.data.map((element) => {
                        return {
                            value: element,
                            label: element?.address ? element.address : element,
                        };
                    });
                    return data;
                }
                return [];
            });
        }
    };
    useEffect(()=>{
        const reasons=[];
        getInvoiceCorrectionReasons().then((result)=>{ 
            if(result.status==200 && result.data.length>0){
                // setInvoiceCorrectionReasonData(result.data);
                result.data.forEach((element)=>{
                    reasons.push({
                        value:element.id,
                        label:element.reason
                    })
                })
                setInvoiceCorrectionReasonData(reasons);
            }
        })
        .catch((err)=>{ 
            showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
        })
    },[])
    const searchBooking = (bookingNumber) => {
        setIsEdit(false)
        setIsSave(false)
        setInvoiceCorrectionReason("")
        checkInvoiceAllow({ bookingNo: bookingNumber }).then(result => {
            getTripByBookingNo({ bookingNo: bookingNumber }).then(result => {
                setTripDetails(result.data)
                getCustomerInvoice({ tripId: result.data.id }).then(result => {
                    let customerInvoiceData = result.data;
                    setCustomerInvoice(result.data)
                    reset({
                        customerBalance: result.data.customerBalance ? result.data.customerBalance.toString() : 0,
                        tollTax: result.data.tollTax.toString(),
                        totalDistance: result.data.totalDistanceInKm.toString(),
                        tripStartTime: new Date(result.data.tripStartTime),
                        updatedTripStartTime: "",
                        tripEndTime: new Date(result.data.tripEndTime),
                        updatedTripEndTime: "",
                        pickupLocation: {
                            address: result.data.pickUpAddress,
                            lat: result.data.pickUpLat,
                            lng: result.data.pickUpLng,
                        },
                        pickupAddress: result.data.pickUpAddress,
                        destLocation: {
                            address: result.data.destAddress,
                            lat: result.data.destLat,
                            lng: result.data.destLng,
                        },
                        destAddress: result.data.destAddress,
                        customerName: result.data.customerName || "",
                        customerNumber: result.data.customerMobile || "",
                        updatedCustomerName: "",
                        updatedCustomerNumber:"",
                    })
                    getInvoiceCorrection({ bookingNo: bookingNumber }).then(result => {
                        setInvoiceCorrectionData(result.data)
                        let invoiceCorrectionData = result.data
                        if (result.status == 200) {
                            setIsUpdateInvoiceCorrection(true)
                            customerInvoiceData = {
                                ...customerInvoiceData,
                                destAddress: result.data.updatedDestAddress ? result.data.updatedDestAddress : result.data.destAddress,
                                destLat: result.data.updatedDestLat ? result.data.updatedDestLat : result.data.destLat,
                                destLng: result.data.updatedDestLng ? result.data.updatedDestLng : result.data.destLng,
                                pickUpAddress: result.data.updatedPickUpAddress ? result.data.updatedPickUpAddress : result.data.pickUpAddress,
                                pickUpLat: result.data.updatedPickUpLat ? result.data.updatedPickUpLat : result.data.pickUpLat,
                                pickUpLng: result.data.updatedPickUpLng ? result.data.updatedPickUpLng : result.data.pickUpLng,
                                totalDistance: result.data.updatedTotalDistanceInKm,
                                totalDistanceInKm: result.data.updatedTotalDistanceInKm,
                                customerBalance: result.data.updatedCustomerBalance,
                                tollTax: result.data.updatedOtherCharges,
                                updatedDestLat: result.data.updatedDestLat,
                                updatedDestLng: result.data.updatedDestLng,
                                updatedPickUpLat: result.data.updatedPickUpLat,
                                updatedPickUpLng: result.data.updatedPickUpLng,
                                tripStartTime: result.data.updatedTripStartTime,
                                tripEndTime: result.data.updatedTripEndTime,
                                updatedTripEndTime: result.data.updatedTripEndTime,
                                updatedTripStartTime: result.data.updatedTripStartTime,
                                customerName: result.data.updatedCustomerName || "",
                                customerNumber: result.data.updatedCustomerMobile || "",
                                updatedCustomerName: result.data.updatedCustomerName || "",
                                updatedCustomerNumber: result.data.updatedCustomerMobile || "",
                            }
                            recalculateInvoiceCorrection(customerInvoiceData).then(result => {
                                // setIsSave(true)
                                setInvoiceCorrectionDetails(result.data)
                                reset({
                                    customerBalance: result.data.updatedCustomerBalance ? result.data.updatedCustomerBalance.toString() : 0,
                                    tollTax: result.data.tollTax.toString(),
                                    totalDistance: result.data.totalDistanceInKm.toString(),
                                    tripStartTime: new Date(result.data.tripStartTime),
                                    updatedTripStartTime: result.data.updatedTripStartTime ? new Date(result.data.updatedTripStartTime) : "",
                                    tripEndTime: new Date(result.data.tripEndTime),
                                    updatedTripEndTime: result.data.updatedTripEndTime ? new Date(result.data.updatedTripEndTime) : "",
                                    pickupLocation: {
                                        address: result.data.pickUpAddress,
                                        lat: result.data.pickUpLat,
                                        lng: result.data.pickUpLng,
                                    },
                                    pickupAddress: result.data.pickUpAddress,
                                    destLocation: {
                                        address: result.data.destAddress,
                                        lat: result.data.destLat,
                                        lng: result.data.destLng,
                                    },
                                    destAddress: result.data.destAddress,
                                })
                            }).catch((err) => {
                                showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
                            })
                        }
                    })
                }).catch((err) => {
                    showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
                })
            }).catch((err) => {
                showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
            })
        }).catch((err) => {
            showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
        })
    }
    const handleUpdatedCustNumber = () => {
        const value=getValues("updatedCustomerNumber");
        if(value.length===10){
            setError("");
            return true;
        }
        else if(value.length>0 && value.length<10){
            setError("Please enter a valid 10 digit mobile number");
            return false;
        }
        else{
            setError("");
        }
        return true;
    }
    const recalculateInvoice = (values) => {
        if (!values.destLocation?.address) {
            showAlert("error", "Please enter a valid destination address")
            return
        }
        if (!values.pickupLocation?.address) {
            showAlert("error", "Please enter a valid pickup address")
            return
        }
        if(!handleUpdatedCustNumber()){
            return;
        }
        let obj = {
            ...customerInvoice,
            destAddress: values.destLocation.address,
            destLat: values.destLocation.lat,
            destLng: values.destLocation.lng,
            pickUpAddress: values.pickupLocation.address,
            pickUpLat: values.pickupLocation.lat,
            pickUpLng: values.pickupLocation.lng,
            totalDistance: Number(values.totalDistance),
            totalDistanceInKm: Number(values.totalDistance),
            customerBalance: values.customerBalance,
            tollTax: values.tollTax,
            updatedDestLat: values.destLocation.lat,
            updatedDestLng: values.destLocation.lng,
            updatedPickUpLat: values.pickupLocation.lat,
            updatedPickUpLng: values.pickupLocation.lng,
            tripStartTime: new Date(values.updatedTripStartTime),
            tripEndTime: new Date(values.updatedTripEndTime),
            updatedTripEndTime: new Date(values.updatedTripEndTime),
            updatedTripStartTime: new Date(values.updatedTripStartTime),
            updatedCustomerName:values.updatedCustomerName?values.updatedCustomerName:null, 
            updatedCustomerMobile:values.updatedCustomerNumber?values.updatedCustomerNumber:null,
            correctionReasonId:invoiceCorrectionReason?invoiceCorrectionReason.value : ""
        }
        recalculateInvoiceCorrection(obj).then(result => {
            setInvoiceCorrectionDetails(result.data)
            reset({
                // keep existing form values and update needed data
                ...getValues(),
                customerBalance: result.data.updatedCustomerBalance ? result.data.updatedCustomerBalance.toString() : 0,
                tollTax: result.data.tollTax.toString(),
                totalDistance: result.data.totalDistanceInKm.toString(),
                tripStartTime: new Date(result.data.tripStartTime),
                updatedTripStartTime: result.data.updatedTripStartTime ? new Date(result.data.updatedTripStartTime) : "",
                tripEndTime: new Date(result.data.tripEndTime),
                updatedTripEndTime: result.data.updatedTripEndTime ? new Date(result.data.updatedTripEndTime) : "",
                pickupLocation: {
                    address: result.data.pickUpAddress,
                    lat: result.data.pickUpLat,
                    lng: result.data.pickUpLng,
                },
                pickupAddress: result.data.pickUpAddress,
                destLocation: {
                    address: result.data.destAddress,
                    lat: result.data.destLat,
                    lng: result.data.destLng,
                },
                destAddress: result.data.destAddress,
            })
            setIsSave(true)
        }).catch((err) => {
            showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
        })
    }
    const onFormSubmit = () => {
        if (!invoiceCorrectionDetails?.pickUpAddress) {
            showAlert("error", "Please enter a valid pickup address")
            return
        }
        if (!invoiceCorrectionDetails?.destAddress) {
            showAlert("error", "Please enter a valid pickup address")
            return
        }
        if (isUpdateInvoiceCorrection) {
            let obj = {
                tripId: customerInvoice.tripId,
                megaCabsBookingNo: customerInvoice.megaCabsBookingNo,
                serviceCityId: customerInvoice.serviceCityId,
                totalDistanceInKm: customerInvoice.totalDistanceInKm,
                totalFare: customerInvoice.totalFare,
                pickUpAddress: customerInvoice.pickUpAddress,
                destAddress: customerInvoice.destAddress,
                grandTax: customerInvoice.grandTax,
                grandFare: customerInvoice.grandFare,
                customerBalance: customerInvoice?.currentBalance ? customerInvoice.currentBalance : 0,
                tripStartTime: customerInvoice.tripStartTime,
                tripEndTime: customerInvoice.tripEndTime,
                otherCharges: invoiceCorrectionData?.otherCharges ? invoiceCorrectionData.otherCharges : 0,
                pickupAddress: customerInvoice.pickupAddress,
                pickUpLat: customerInvoice.pickUpLat,
                pickUpLng: customerInvoice.pickUpLng,
                destAddress: customerInvoice.destAddress,
                destLat: customerInvoice.destLat,
                destLng: customerInvoice.destLng,
                isCompletetoCancel: customerInvoice.isCompletetoCancel,
                updatedTotalDistanceInKm: invoiceCorrectionDetails.totalDistance,
                updatedTotalFare: invoiceCorrectionDetails.totalFare,
                updatedPickUpAddress: invoiceCorrectionDetails.pickUpAddress,
                updatedDestAddress: invoiceCorrectionDetails.destAddress,
                updatedCustomerBalance: invoiceCorrectionDetails.updatedCustomerBalance,
                id: invoiceCorrectionData.id,
                updatedTripStartTime: invoiceCorrectionDetails.updatedTripStartTime,
                updatedTripEndTime: invoiceCorrectionDetails.updatedTripEndTime,
                updatedOtherCharges: invoiceCorrectionDetails.tollTax,
                updatedPickUpLat: invoiceCorrectionDetails.updatedPickUpLat,
                updatedPickUpLng: invoiceCorrectionDetails.updatedPickUpLng,
                updatedDestLat: invoiceCorrectionDetails.updatedDestLat,
                updatedDestLng: invoiceCorrectionDetails.updatedDestLng,
                updatedGrandTax: invoiceCorrectionDetails.grandTax,
                updatedGrandFare: invoiceCorrectionDetails.grandFare,
                createdOn: invoiceCorrectionData.createdOn,
                createdById: invoiceCorrectionData.createdById,
                isDeleted: invoiceCorrectionData.isDeleted,
                deletedOn: invoiceCorrectionData.deletedOn,
                deletedById: invoiceCorrectionData.deletedById,
                status: invoiceCorrectionData.status,
                customerName: customerInvoice.customerName,
                updatedCustomerName: invoiceCorrectionDetails.updatedCustomerName? invoiceCorrectionDetails.updatedCustomerName : null,
                customerMobile: customerInvoice.customerMobile,
                updatedCustomerMobile: invoiceCorrectionDetails.updatedCustomerMobile? invoiceCorrectionDetails.updatedCustomerMobile : null,
                correctionReasonId:invoiceCorrectionReason.value    
            }

            updateInvoiceCorrection(obj).then((result) => {
                showAlert("success", "Trip Invoice Correction Saved")
                navigate("/bookings/invoice-list")
            }).catch((err) => {
                showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
            })

        } else {
            let obj = {
                tripId: customerInvoice.tripId,
                megaCabsBookingNo: customerInvoice.megaCabsBookingNo,
                serviceCityId: customerInvoice.serviceCityId,
                totalDistanceInKm: customerInvoice.totalDistanceInKm,
                totalFare: customerInvoice.totalFare,
                pickUpAddress: customerInvoice.pickUpAddress,
                destAddress: customerInvoice.destAddress,
                grandTax: customerInvoice.grandTax,
                grandFare: customerInvoice.grandFare,
                customerBalance: 0,
                tripStartTime: customerInvoice.tripStartTime,
                tripEndTime: customerInvoice.tripEndTime,
                otherCharges: 0,
                pickUpLat: customerInvoice.pickUpLat,
                pickUpLng: customerInvoice.pickUpLng,
                destLat: customerInvoice.destLat,
                destLng: customerInvoice.destLng,
                isCompletetoCancel: customerInvoice.isCompletetoCancel,
                updatedTotalDistanceInKm: invoiceCorrectionDetails.totalDistance,
                updatedTotalFare: invoiceCorrectionDetails.totalFare,
                updatedPickUpAddress: invoiceCorrectionDetails.pickUpAddress,
                updatedDestAddress: invoiceCorrectionDetails.destAddress,
                updatedCustomerBalance: invoiceCorrectionDetails.updatedCustomerBalance,
                updatedTripStartTime: invoiceCorrectionDetails.updatedTripStartTime,
                updatedTripEndTime: invoiceCorrectionDetails.updatedTripEndTime,
                updatedOtherCharges: invoiceCorrectionDetails.tollTax,
                updatedPickUpLat: invoiceCorrectionDetails.updatedPickUpLat,
                updatedPickUpLng: invoiceCorrectionDetails.updatedPickUpLng,
                updatedDestLat: invoiceCorrectionDetails.updatedDestLat,
                updatedDestLng: invoiceCorrectionDetails.updatedDestLng,
                updatedGrandTax: invoiceCorrectionDetails.grandTax,
                updatedGrandFare: invoiceCorrectionDetails.grandFare,
                status: "InProgress",
                customerName: customerInvoice.customerName,
                updatedCustomerName: invoiceCorrectionDetails.updatedCustomerName? invoiceCorrectionDetails.updatedCustomerName : null,
                customerMobile: customerInvoice.customerMobile,
                updatedCustomerMobile: invoiceCorrectionDetails.updatedCustomerMobile? invoiceCorrectionDetails.updatedCustomerMobile : null,
                correctionReasonId:invoiceCorrectionReason.value
            }

            createInvoiceCorrection(obj).then((result) => {
                showAlert("success", "Trip Invoice Correction Saved")
                navigate("/bookings/invoice-list")
            }).catch((err) => {
                showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
            })
        }
    }

    const cancelInvoice = () => {
        setIsEdit(false)
        getInvoiceCorrection({ bookingNo: bookingNumber }).then(result => {
            setInvoiceCorrectionData(result.data)
            let invoiceCorrectionData = result.data
            if (result.status == 200) {
                let customerInvoiceData = {
                    ...customerInvoice,
                    destAddress: result.data.updatedDestAddress,
                    destLat: result.data.updatedDestLat,
                    destLng: result.data.updatedDestLng,
                    pickUpAddress: result.data.updatedPickUpAddress,
                    pickUpLat: result.data.updatedPickUpLat,
                    pickUpLng: result.data.updatedPickUpLng,
                    totalDistance: result.data.updatedTotalDistanceInKm,
                    totalDistanceInKm: result.data.updatedTotalDistanceInKm,
                    updatedCustomerBalance: result.data.customerBalance,
                    tollTax: result.data.updatedOtherCharges,
                    updatedDestLat: result.data.updatedDestLat,
                    updatedDestLng: result.data.updatedDestLng,
                    updatedPickUpLat: result.data.updatedPickUpLat,
                    updatedPickUpLng: result.data.updatedPickUpLng,
                    tripStartTime: result.data.updatedTripStartTime,
                    tripEndTime: result.data.updatedTripEndTime,
                    updatedTripEndTime: result.data.updatedTripEndTime,
                    updatedTripStartTime: result.data.updatedTripStartTime,
                    customerName: customerInvoice.customerName,
                    updatedCustomerName: invoiceCorrectionDetails.updatedCustomerName,
                    customerMobile: customerInvoice.customerMobile,
                    updatedCustomerMobile: invoiceCorrectionDetails.updatedCustomerMobile
                }
                recalculateInvoiceCorrection(customerInvoiceData).then(result => {
                    // setIsSave(true)
                    setInvoiceCorrectionDetails(result.data)
                    reset({
                        customerBalance: result.data.customerBalance ? result.data.customerBalance.toString() : 0,
                        tollTax: result.data.tollTax.toString(),
                        totalDistance: result.data.totalDistanceInKm.toString(),
                        tripStartTime: new Date(result.data.tripStartTime),
                        updatedTripStartTime: result.data.updatedTripStartTime ? new Date(result.data.updatedTripStartTime) : "",
                        tripEndTime: new Date(result.data.tripEndTime),
                        updatedTripEndTime: result.data.updatedTripEndTime ? new Date(result.data.updatedTripEndTime) : "",
                        pickupLocation: {
                            address: result.data.pickUpAddress,
                            lat: result.data.pickUpLat,
                            lng: result.data.pickUpLng,
                        },
                        pickupAddress: result.data.pickUpAddress,
                        destLocation: {
                            address: result.data.destAddress,
                            lat: result.data.destLat,
                            lng: result.data.destLng,
                        },
                        destAddress: result.data.destAddress,
                    })
                    toggleCancelBookingModal()
                }).catch((err) => {
                    showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
                })
            }
        })
    }

    const onReasonSubmit = (formValues) => {
        if (isUpdateInvoiceCorrection) {
            let obj = {
                cancelledReason: formValues.reason.reason,
                cancelledReasonCode: formValues.reason.reasonCode,
                cancelledReasonRemarks: formValues.detailed_reason,
                tripId: customerInvoice.tripId,
                megaCabsBookingNo: customerInvoice.megaCabsBookingNo,
                serviceCityId: customerInvoice.serviceCityId,
                totalDistanceInKm: customerInvoice.totalDistanceInKm,
                totalFare: customerInvoice.totalFare,
                pickUpAddress: customerInvoice.pickUpAddress,
                destAddress: customerInvoice.destAddress,
                grandTax: customerInvoice.grandTax,
                grandFare: customerInvoice.grandFare,
                customerBalance: customerInvoice?.currentBalance ? customerInvoice.currentBalance : 0,
                tripStartTime: customerInvoice.tripStartTime,
                tripEndTime: customerInvoice.tripEndTime,
                otherCharges: invoiceCorrectionData?.otherCharges ? invoiceCorrectionData.otherCharges : 0,
                pickUpLat: customerInvoice.pickUpLat,
                pickUpLng: customerInvoice.pickUpLng,
                destLat: customerInvoice.destLat,
                destLng: customerInvoice.destLng,
                isCompletetoCancel: customerInvoice.isCompletetoCancel,
                updatedTotalDistanceInKm: invoiceCorrectionDetails.totalDistance,
                updatedTotalFare: invoiceCorrectionDetails.totalFare,
                updatedPickUpAddress: invoiceCorrectionDetails.pickUpAddress,
                updatedDestAddress: invoiceCorrectionDetails.destAddress,
                updatedCustomerBalance: invoiceCorrectionDetails.customerBalance,
                id: invoiceCorrectionData.id,
                updatedTripStartTime: invoiceCorrectionDetails.updatedTripStartTime,
                updatedTripEndTime: invoiceCorrectionDetails.updatedTripEndTime,
                updatedOtherCharges: invoiceCorrectionDetails.tollTax,
                updatedPickUpLat: invoiceCorrectionDetails.updatedPickUpLat,
                updatedPickUpLng: invoiceCorrectionDetails.updatedPickUpLng,
                updatedDestLat: invoiceCorrectionDetails.updatedDestLat,
                updatedDestLng: invoiceCorrectionDetails.updatedDestLng,
                updatedGrandTax: invoiceCorrectionDetails.grandTax,
                updatedGrandFare: invoiceCorrectionDetails.grandFare,
                createdOn: invoiceCorrectionData.createdOn,
                createdById: invoiceCorrectionData.createdById,
                isDeleted: invoiceCorrectionData.isDeleted,
                deletedOn: invoiceCorrectionData.deletedOn,
                deletedById: invoiceCorrectionData.deletedById,
                status: invoiceCorrectionData.status,
                customerName: customerInvoice.customerName,
                updatedCustomerName: invoiceCorrectionDetails.updatedCustomerName,
                customerMobile: customerInvoice.customerMobile,
                updatedCustomerMobile: invoiceCorrectionDetails.updatedCustomerMobile
            }

            updateInvoiceCorrection(obj).then((result) => {
                showAlert("success", "Trip Invoice Correction Saved")
                navigate("/bookings/invoice-list")
            }).catch((err) => {
                showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
            })

        } else {
            let obj = {
                tripId: customerInvoice.tripId,
                megaCabsBookingNo: customerInvoice.megaCabsBookingNo,
                serviceCityId: customerInvoice.serviceCityId,
                totalDistanceInKm: customerInvoice.totalDistanceInKm,
                totalFare: customerInvoice.totalFare,
                pickUpAddress: customerInvoice.pickUpAddress,
                destAddress: customerInvoice.destAddress,
                grandTax: customerInvoice.grandTax,
                grandFare: customerInvoice.grandFare,
                customerBalance: 0,
                tripStartTime: customerInvoice.tripStartTime,
                tripEndTime: customerInvoice.tripEndTime,
                otherCharges: 0,
                pickUpLat: customerInvoice.pickUpLat,
                pickUpLng: customerInvoice.pickUpLng,
                destLat: customerInvoice.destLat,
                destLng: customerInvoice.destLng,
                isCompletetoCancel: customerInvoice.isCompletetoCancel,
                updatedTotalDistanceInKm: invoiceCorrectionDetails.totalDistance,
                updatedTotalFare: invoiceCorrectionDetails.totalFare,
                updatedPickUpAddress: invoiceCorrectionDetails.pickUpAddress,
                updatedDestAddress: invoiceCorrectionDetails.destAddress,
                updatedCustomerBalance: 0,
                updatedTripStartTime: invoiceCorrectionDetails.updatedTripStartTime,
                updatedTripEndTime: invoiceCorrectionDetails.updatedTripEndTime,
                updatedOtherCharges: invoiceCorrectionDetails.tollTax,
                updatedPickUpLat: invoiceCorrectionDetails.updatedPickUpLat,
                updatedPickUpLng: invoiceCorrectionDetails.updatedPickUpLng,
                updatedDestLat: invoiceCorrectionDetails.updatedDestLat,
                updatedDestLng: invoiceCorrectionDetails.updatedDestLng,
                updatedGrandTax: invoiceCorrectionDetails.grandTax,
                updatedGrandFare: invoiceCorrectionDetails.grandFare,
                status: "InProgress",
                customerName: customerInvoice.customerName,
                updatedCustomerName: invoiceCorrectionDetails.updatedCustomerName,
                customerMobile: customerInvoice.customerMobile,
                updatedCustomerMobile: invoiceCorrectionDetails.updatedCustomerMobile
            }

            createInvoiceCorrection(obj).then((result) => {
                showAlert("success", "Trip Invoice Correction Saved")
                navigate("/bookings/invoice-list")
            }).catch((err) => {
                showAlert("error", err.response?.data?.message ? err.response.data?.message : "Something went wrong")
            })
        }
    }

    const handleReset = () => {
        setBookingNumber("")
        setTripDetails({})
        setCustomerInvoice({})
        setInvoiceCorrectionData({})
        setInvoiceCorrectionDetails({})
        setIsUpdateInvoiceCorrection(false)
        reset({
            customerBalance: "",
            tollTax: "",
            totalDistance: "",
            tripStartTime: "",
            updatedTripStartTime: "",
            tripEndTime: "",
            updatedTripEndTime: "",
            pickupLocation: {},
            pickupAddress: "",
            destLocation: {},
            destAddress: "",
            customerName: "",
            customerNumber: "",
            updatedCustomerName: "",
            updatedCustomerNumber: "",
        })
        setIsEdit(false)
        setIsSave(false)
    }

    console.log("customer invoice", customerInvoice)
    console.log("values", getValues())

    return (
        <div style={{ padding: "20px" ,paddingBottom: isDropdownOpen ? '250px' : '0',
    transition: 'padding-bottom 0.3s ease'}}>
            <p style={{ fontSize: "16px", textAlign: "center" }}>TRIP INVOICE CORRECTION</p>
            <div >
                <label>Find Trip</label>
                <div style={{ display: "flex" }}>
                    <input
                        className="form-control"
                        placeholder="Enter Booking Number"
                        value={bookingNumber}
                        onChange={(e) => setBookingNumber(e.target.value.trimStart())}
                        onKeyDown={(e) => {
                            if (e.key == 'Enter') {
                                if (bookingNumber) {
                                    searchBooking(bookingNumber)
                                } else {
                                    showAlert("error", "Please enter a valid booking number.")
                                }
                            }
                        }}
                    />
                    <button className="btn btn-primary" style={{ marginRight: "10px", marginLeft: "10px" }} onClick={() => {
                        if (bookingNumber) {
                            searchBooking(bookingNumber)
                        } else {
                            showAlert("error", "Please enter a valid booking number.")
                        }
                    }}>
                        <i className="fa fa-search"></i>
                    </button>
                    <button className="btn btn-primary" onClick={handleReset}>
                        Reset
                    </button>
                </div>
            </div>
            <div style={{ marginTop: "30px", display: "flex" }}>
                <div className="col-md-4">
                    <div className="col-12 row mb-1" style={{ alignItems: "center" }}><div className="col-6">Booking No:</div><div className="col-6 p-0">{tripDetails.megaCabsBookingNo}</div></div>
                    <div className="col-12 row mb-1" style={{ alignItems: "center" }}><div className="col-6">Status:</div><div className="col-6 p-0">{tripDetails.currentTripStatusType}</div></div>
                    <div className="col-12 row mb-1" style={{ alignItems: "center" }}><div className="col-6">Customer Details:</div><div className="col-6 p-0"><div>{tripDetails.custName}</div><div>{tripDetails.custEmail}</div><div>{tripDetails.custMobile}</div></div></div>
                    <div className="col-12 row mb-1" style={{ alignItems: "center" }}><div className="col-6">Total Fare:</div><div className="col-6 row p-0" style={{ alignItems: "center" }}><input className="form-control" style={{ width: "70%", height: "95%", marginRight: "10px" }} value={Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails.totalFare : customerInvoice?.totalFare ? customerInvoice?.totalFare : ""} disabled /> INR.</div></div>
                    {Object.keys(customerInvoice).length > 0 ?
                        customerInvoice.advanceAmount != "0" ?
                            <div className="col-12 row mb-1" style={{ alignItems: "center" }}><div className="col-6">Advance Paid:</div><div className="col-6 row" style={{ alignItems: "center" }}><input className="form-control" style={{ width: "70%", height: "95%", marginRight: "10px" }} value={customerInvoice?.advanceAmount} disabled /> INR.</div></div>
                            : <></>
                        : <div className="col-12 row mb-1" style={{ alignItems: "center" }}><div className="col-6">Advance Paid:</div><div className="col-6 row" style={{ alignItems: "center" }}><input className="form-control" style={{ width: "70%", height: "95%", marginRight: "10px" }} value={""} disabled /> INR.</div></div>}
                    {Object.keys(customerInvoice).length > 0 ? customerInvoice.bookedKM != "0" ? (<div className="col-12 row mb-1" style={{ alignItems: "center" }}><div className="col-6">Booked Distance:</div><div className="col-6 row" style={{ alignItems: "center" }}><input className="form-control" style={{ width: "70%", height: "95%", marginRight: "10px" }} value={customerInvoice?.bookedKM} disabled /> KM.</div></div>) : (<></>) : (<div className="col-12 row mb-1" style={{ alignItems: "center" }}><div className="col-6">Booked Distance:</div><div className="col-6 row" style={{ alignItems: "center" }}><input className="form-control" style={{ width: "70%", height: "95%", marginRight: "10px" }} disabled value={""} /> KM.</div></div>)}
                    <div style={{ display: "flex", alignItems: "center", margin: "20px 0px", justifyContent: "center" }}>
                        <button className="btn btn-primary" style={{ marginRight: "10px" }} onClick={() => cancelInvoice()}>
                            Cancel
                        </button>
                        <button className="btn btn-primary" onClick={() => {
                            if (!bookingNumber) {
                                showAlert("error", "Please enter a valid booking number.")
                                return;
                            }
                            if (tripDetails.currentTripStatusType != "Complete") {
                                showAlert("error", "Trip is in progress.")
                                return;
                            }
                            setIsEdit(true)
                        }}>
                            Edit
                        </button>
                    </div>
                </div>
                <div className="col-md-8 row">
                    <div className="col-6">
                        <table style={{ width: "100%" }}>
                            <tr>
                                <th>Fare Breakup</th>
                                <th style={{ textAlign: "right" }}>(INR)</th>
                            </tr>
                            <tr>
                                <td>{Object.keys(invoiceCorrectionDetails).length > 0 ? `Flag Down charges(upto ${customerInvoice.initialKM}km)` : Object.keys(customerInvoice).length > 0 ? `Flag Down charges(upto ${customerInvoice.initialKM}km)` : "Base Fare"}</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.intialCharge?.toFixed(2) : customerInvoice?.intialCharge?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>{Object.keys(invoiceCorrectionDetails).length > 0 ? `Extra ${invoiceCorrectionDetails.extraKM} KM @Rs.${invoiceCorrectionDetails.ratePerKM}` : Object.keys(customerInvoice).length > 0 ? `Extra ${customerInvoice.extraKM} KM @Rs.${customerInvoice.ratePerKM}` : ""}</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.alteredBaseFare?.toFixed(2) : customerInvoice?.alteredBaseFare?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>{customerInvoice?.serviceCityId==1?"Airport Parking Fee":"Airport Parking Charges"}</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.airportParkingCharges?.toFixed(2) : customerInvoice?.airportParkingCharges?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>{Object.keys(invoiceCorrectionDetails).length > 0 ? `Ride Time ${invoiceCorrectionDetails.totalRideTime} mins @Rs.${invoiceCorrectionDetails.rideCharge.toFixed(2)}` : Object.keys(customerInvoice).length > 0 ? `Ride Time ${customerInvoice.totalRideTime} mins @Rs.${customerInvoice.rideCharge.toFixed(2)}` : "Ride Charges"}</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.rideTimeCharges?.toFixed(2) : customerInvoice?.rideTimeCharges?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Waiting Charges</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.waitingCharges?.toFixed(2) : customerInvoice?.waitingCharges?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>{customerInvoice?.serviceCityId==1?"Airport Convenience charge":"Convenience Charge"}</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.convenienceCharge?.toFixed(2) : customerInvoice?.convenienceCharge?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Toll Tax/Other</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.tollTax?.toFixed(2) : customerInvoice?.tollTax?.toFixed(2)}</td>
                            </tr>
                        </table>
                    </div>
                    <div className="col-6">
                        <table style={{ width: "100%" }}>
                            <tr>
                                <th>Tax Breakup</th>
                                <th style={{ textAlign: "right" }}>(INR)</th>
                            </tr>
                            <tr>
                                <td>CGST</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.kisanCess?.toFixed(2) : customerInvoice?.kisanCess?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>SGST</td>
                                <td style={{ textAlign: "right" }}>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.swachhBharatCess?.toFixed(2) : customerInvoice?.swachhBharatCess?.toFixed(2)}</td>
                            </tr>
                            <tr style={{ height: "30px" }}>
                                <td>{" "}</td>
                                <td style={{ textAlign: "right" }}></td>
                            </tr>
                            <tr>
                                <td>* {Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.invoiceLabel : customerInvoice?.invoiceLabel}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{Object.keys(invoiceCorrectionDetails).length > 0 ? invoiceCorrectionDetails?.packageRemarks : customerInvoice?.packageRemarks}</td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            {isEdit && <Form style={{ marginTop: "30px", display: "flex" }} onSubmit={handleSubmit(recalculateInvoice)}>
                <div className="col-md-4">
                    <div className="col-12 row mb-1" style={{ alignItems: "center" }}>
                        <div className="col-6">Customer Balance:</div>
                        <div className="col-6 row" style={{ alignItems: "center" }}>
                            <input
                                className="form-control"
                                type="text"
                                style={{ width: "65%", height: "95%", marginRight: "10px" }}
                                value={customerBalanceField.value}
                                pattern="[0-9.]+"
                                onChange={(e) => {
                                    customerBalanceField.onChange(e.target.value.replace(/[^0-9.]/g, ''))
                                }}
                            /> INR.
                        </div>
                    </div>
                    <div className="col-12 row mb-1" style={{ alignItems: "center" }}>
                        <div className="col-6">MCD/Toll Tax/Other Charges:</div>
                        <div className="col-6 row" style={{ alignItems: "center" }}>
                            <input
                                className="form-control"
                                type="text"
                                style={{ width: "65%", height: "95%", marginRight: "10px" }}
                                value={tollTaxField.value}
                                pattern="[0-9.]+"
                                onChange={(e) => {
                                    tollTaxField.onChange(e.target.value.replace(/[^0-9.]/g, ''))
                                }}
                            />
                            INR.
                        </div>
                    </div>
                    <div className="col-12 row mb-1" style={{ alignItems: "center" }}>
                        <div className="col-6">Total Distance:</div>
                        <div className="col-6 row" style={{ alignItems: "center" }}>
                            <input
                                className="form-control"
                                type="text"
                                style={{ width: "65%", height: "95%", marginRight: "10px" }}
                                value={totalDistanceField.value}
                                pattern="[0-9.]+"
                                onChange={(e) => {
                                    totalDistanceField.onChange(e.target.value.replace(/[^0-9.]/g, ''))
                                }}
                            />
                            KM.
                        </div>
                    </div>
                </div>
                <div className="col-md-8 row">
                    <div className="col-12 row mb-2">
                        <div className="col-4">Customer Name:</div>
                        <div  className="col-8">
                            <input
                                disabled
                                className="form-control"
                                type="text"
                                // style={{ width: "65%", height: "95%", marginRight: "10px" }}
                                value={customerNameField.value}
                            /> 
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Updated Customer Name:</div>
                        <div  className="col-8">
                            <input
                                className="form-control"
                                type="text"
                                value={updatedCustomerNameField.value}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    updatedCustomerNameField.onChange(value);
                                }}
                                onBlur={(e) => {
                                    const trimmedValue = e.target.value.trim();
                                    updatedCustomerNameField.onChange(trimmedValue || null);
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Customer Number:</div>
                        <div  className="col-8">
                            <input
                                disabled
                                className="form-control"
                                type="text"
                                // style={{ width: "65%", height: "95%", marginRight: "10px" }}
                                value={customerNumberField.value}
                            /> 
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Updated Customer Number:</div>
                        <div  className="col-8">
                            <input
                                className="form-control"
                                type="text"
                                // style={{ width: "65%", height: "95%", marginRight: "10px" }}
                                maxLength={10}
                                value={updatedCustomerNumberField.value}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                    updatedCustomerNumberField.onChange(value);
                                }}
                            /> 
                            {error.length>0 && <div className="text-danger small mt-1">{error}</div>}
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Actual Trip Start Time:</div>
                        <div className="col-8">
                            <DatePicker
                                disabled
                                className="form-control datetimepicker-input digits"
                                selected={tripStartTimeField.value}
                                showTimeSelect
                                showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                onChange={(date) => tripStartTimeField.onChange(date)}
                                dateFormat="MMMM d yyyy, h:mm:ss a"
                                {...register("tripStartTime", {})}
                            />
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Update Trip Start Time:</div>
                        <div className="col-8">
                            <DatePicker
                                className="form-control datetimepicker-input digits"
                                selected={updatedTripStartTimeField.value}
                                showTimeSelect
                                showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                onChange={(date) => updatedTripStartTimeField.onChange(date)}
                                dateFormat="MMMM d yyyy, h:mm:ss a"
                            />
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Actual Trip End Time:</div>
                        <div className="col-8">
                            <DatePicker
                                disabled
                                className="form-control datetimepicker-input digits"
                                selected={tripEndTimeField.value}
                                showTimeSelect
                                showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                onChange={(date) => tripEndTimeField.onChange(date)}
                                dateFormat="MMMM d yyyy, h:mm:ss a"
                            />
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Update Trip End Time:</div>
                        <div className="col-8">
                            <DatePicker
                                className="form-control datetimepicker-input digits"
                                selected={updatedTripEndTimeField.value}
                                showTimeSelect
                                showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                onChange={(date) => updatedTripEndTimeField.onChange(date)}
                                dateFormat="MMMM d yyyy, h:mm:ss a"
                            />
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Pickup Address:</div>
                        <div className="col-8">
                            <CustomAutoSuggest
                                id={"pickupLocation"}
                                handleSelectChange={handlePickupLocationSelectChange}
                                options={getAddressData}
                                placeholder="Enter pickup address"
                                registerName={"pickupAddress"}
                                register={register}
                                isClearable={true}
                                setValue={setValue}
                                watch={watch}
                                inputProps={{
                                    // required: {
                                    //     value: true,
                                    //     message: "Location is required",
                                    // },
                                }}
                                dependentRegisterName={"pickupLocation"}
                            />
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Destination Address:</div>
                        <div className="col-8">
                            <CustomAutoSuggest
                                id={"destLocation"}
                                handleSelectChange={handleDestLocationSelectChange}
                                options={getAddressData}
                                placeholder="Enter destination address"
                                registerName={"destAddress"}
                                register={register}
                                isClearable={true}
                                setValue={setValue}
                                watch={watch}
                                inputProps={{
                                    // required: {
                                    //     value: true,
                                    //     message: "Location is required",
                                    // },
                                }}
                                dependentRegisterName={"destLocation"}
                            />
                        </div>
                    </div>
                    <div className="col-12 row mb-2">
                        <div className="col-4">Invoice Correction Reason :</div>
                        <div className="col-8">
                            <Controller
                                name="invoiceCorrectionReason"
                                control={control}
                                rules={{ required: "Please select a correction reason" }}
                                render={({ field }) => (
                                    <Select
                                    {...field}
                                    value={invoiceCorrectionReason}
                                    onMenuOpen={()=>setIsDropdownOpen(true)}
                                    onMenuClose={()=>setIsDropdownOpen(false)}
                                    onChange={(selectedOption) => {
                                        console.log("selected option insides", selectedOption);
                                        field.onChange(selectedOption);                    
                                        setInvoiceCorrectionReason(selectedOption);     
                                    }}
                                    options={invoiceCorrectionReasonData}
                                    placeholder="Select Reason"
                                    isClearable
                                    classNamePrefix="react-select"
                                    className={errors.invoiceCorrectionReason ? "is-invalid-select" : ""}
                                    styles={{
                                        control: (base) => ({
                                        ...base,
                                        borderColor: errors.invoiceCorrectionReason ? "#dc3545" : base.borderColor,
                                        boxShadow: errors.invoiceCorrectionReason 
                                            ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)" 
                                            : base.boxShadow,
                                        }),
                                    }}
                                    />
                                )}
                            />
                            {errors.invoiceCorrectionReason && (
                            <div className="text-danger small mt-1">
                                {errors.invoiceCorrectionReason.message}
                            </div>
                            )}
                        </div>
                    </div>
                    <div className="col-12 row mb-2 mt-2">
                        <div className="col-4">Check Re-Calculate:</div>
                        <div className="col-8">
                            <button className="btn btn-primary" style={{ marginRight: "10px" }} type="submit" >
                                Re-Calculate
                            </button>
                            {isSave && <button className="btn btn-primary" type="button" onClick={onFormSubmit}>
                                Save
                            </button>}
                        </div>
                    </div>
                </div>
            </Form>}
            <CancelInvoiceCorrection
                LargeModaltoggle={toggleCancelBookingModal}
                title={"Cancel Booking Operation"}
                Large={cancelBookingModal}
                reasonData={reasonData}
                onReasonSubmit={onReasonSubmit}
            />
        </div>
    )
}

export default InvoiceCorrection